import React, { useState } from "react";
import styled from "styled-components";
import PartnerCostManage from "./PartnerCostManage";
import PartnerManagement from "./PartnerManagement";
import Breadcrumbs from "../based/Breadcrumbs";
import { PLATFORM, PLATFORM_NAME } from "../based/Constants";

const TabOption = {
    Partner: 1,
    PercentageCost: 2,
};

const ListTabOption = [
    {
        id: TabOption.Partner,
        name: "Quản lý Partner",
    },
    {
        id: TabOption.PercentageCost,
        name: "Phần trăm chi phí sàn",
    },
];

const ListPlatformOption = [
    {
        id: PLATFORM.Tiktok,
        name: PLATFORM_NAME.Tiktok,
    },
];

function PartnerManagementTotal(props) {
    const [tabId, setTabId] = useState(TabOption.PercentageCost);
    const [platformId, setPlatformId] = useState(PLATFORM.Tiktok);

    return (
        <React.Fragment>
            <Breadcrumbs currentPage="Quản lý Partner" parentPage="Người dùng" />
            <Wrapper>
                <section className="partner-table">
                    <ul className="nav nav-tabs tabs-bordered">
                        {ListTabOption.map((item, index) => {
                            const isActive = item.id == tabId;
                            return (
                                <li className={`nav-item`} key={index}>
                                    <a
                                        className={`nav-link ${isActive ? "active" : ""}`}
                                        data-toggle="tab"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setTabId(item.id);
                                        }}
                                    >
                                        <span>{item.name}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                    {tabId == TabOption.Partner && <PartnerManagement />}
                    {tabId == TabOption.PercentageCost && (
                        <React.Fragment>
                            <ul className="nav nav-tabs tabs-bordered">
                                {ListPlatformOption.map((item, index) => {
                                    const isActive = item.id == platformId;
                                    return (
                                        <li className={`nav-item`} key={index}>
                                            <a
                                                className={`nav-link ${isActive ? "active" : ""}`}
                                                data-toggle="tab"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setPlatformId(item.id);
                                                }}
                                            >
                                                <span>{item.name}</span>
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                            <PartnerCostManage />
                        </React.Fragment>
                    )}
                </section>
            </Wrapper>
        </React.Fragment>
    );
}

export default PartnerManagementTotal;

const Wrapper = styled.div``;
